import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="service-visits--performed-services-form"
export default class extends Controller {
  static targets = [
    "lockerSelect",
    "doorSelect",
    "performedServiceSelect",
    "uiNodeIdField",
    "g7SpaceIdField"
  ]

  static values = {
    performedServices: Object,
    editMode: Boolean
  }

  connect() {
    if (!this.editModeValue) {
      this.hideDoorSelect()
      this.updateMessages()
    }

    // Listen for when locker select is updated via turbo stream
    this.boundHandleTurboRender = this.handleTurboStreamRender.bind(this)
    document.addEventListener('turbo:before-stream-render', this.boundHandleTurboRender)
  }

  disconnect() {
    if (this.boundHandleTurboRender) {
      document.removeEventListener('turbo:before-stream-render', this.boundHandleTurboRender)
    }
  }

  handleTurboStreamRender(event) {
    const { target } = event.detail.newStream

    // When locker select is updated, reset the form
    if (target === 'performed_service_locker_select' && !this.editModeValue) {
      setTimeout(() => {
        this.resetForm()
      }, 10)
    }
  }

  resetForm() {
    if (this.hasLockerSelectTarget) {
      this.lockerSelectTarget.selectedIndex = 0
    }

    if (this.hasDoorSelectTarget) {
      this.doorSelectTarget.innerHTML = '<option value="">Select door</option>'
      this.doorSelectTarget.disabled = true
      this.hideDoorSelect()
    }

    if (this.hasPerformedServiceSelectTarget) {
      this.performedServiceSelectTarget.innerHTML = '<option value="">Select performed service</option>'
      this.performedServiceSelectTarget.disabled = true
    }

    if (this.hasUiNodeIdFieldTarget) this.uiNodeIdFieldTarget.value = ''
    if (this.hasG7SpaceIdFieldTarget) this.g7SpaceIdFieldTarget.value = ''

    this.updateMessages()
  }

  onLockerChange() {
    if (this.lockerSelectTarget.value === "") {
      this.doorSelectTarget.disabled = true
      this.doorSelectTarget.value = ""
      this.uiNodeIdFieldTarget.value = ""
      this.g7SpaceIdFieldTarget.value = ""
      this.hideDoorSelect()
    } else {
      this.updateDoors()
    }

    this.updateMessages()
  }

  onDoorChange() {
    this.updateMessages()
  }

  updateDoors() {
    const selectedValue = this.lockerSelectTarget.value
    const selectedOption = this.lockerSelectTarget.options[this.lockerSelectTarget.selectedIndex]
    const selectedType = selectedOption?.dataset.type

    this.doorSelectTarget.innerHTML = '<option value="">Select door</option>'

    if (selectedType === 'g5') {
      const doorsData = selectedOption?.dataset.doors
      let doors = []

      if (doorsData) {
        try {
          doors = JSON.parse(doorsData)
        } catch (e) {
          console.error('Failed to parse doors data:', e)
        }
      }

      if (doors && doors.length > 0) {
        doors.forEach(door => {
          const option = document.createElement('option')
          option.value = door.id
          option.textContent = door.name
          this.doorSelectTarget.appendChild(option)
        })
        this.doorSelectTarget.disabled = false
        this.showDoorSelect()
      } else {
        this.doorSelectTarget.disabled = true
        this.hideDoorSelect()
      }

      const displayId = selectedValue.replace('ui_node_', '')
      this.uiNodeIdFieldTarget.value = displayId
      this.g7SpaceIdFieldTarget.value = ''

    } else if (selectedType === 'g7') {
      this.doorSelectTarget.disabled = true
      this.doorSelectTarget.value = ''
      this.hideDoorSelect()

      const displayId = selectedValue.replace('g7_space_', '')
      this.g7SpaceIdFieldTarget.value = displayId
      this.uiNodeIdFieldTarget.value = ''

    } else {
      this.doorSelectTarget.disabled = true
      this.hideDoorSelect()
      this.uiNodeIdFieldTarget.value = ''
      this.g7SpaceIdFieldTarget.value = ''
    }
  }

  updateMessages() {
    const messages = this.performedServicesValue
    if (!messages) return

    const selectedOption = this.lockerSelectTarget.options[this.lockerSelectTarget.selectedIndex]
    const selectedType = selectedOption?.dataset.type

    let options = null

    if (selectedType === 'g7') {
      options = messages.space
    } else if (!this.doorSelectTarget.disabled && this.doorSelectTarget.value !== "") {
      options = messages.space
    } else if (this.lockerSelectTarget.value !== "") {
      options = messages.controller
    } else {
      options = messages.location
    }

    this.setNewOptions(options)
  }

  setNewOptions(options) {
    const currentValue = this.performedServiceSelectTarget.value

    Array.from(this.performedServiceSelectTarget.options).forEach(option => {
      if (option.value !== '') {
        option.remove()
      }
    })

    if (options) {
      this.performedServiceSelectTarget.disabled = false
      options.forEach(option => {
        const optionElement = document.createElement('option')
        optionElement.value = option[1]
        optionElement.textContent = option[0]
        this.performedServiceSelectTarget.appendChild(optionElement)
      })
    } else {
      this.performedServiceSelectTarget.disabled = true
    }
  }

  hideDoorSelect() {
    this.doorSelectTarget.style.display = 'none'
  }

  showDoorSelect() {
    this.doorSelectTarget.style.display = ''
  }
}
